/**
 * The Crystal brandmark — a navy tile carrying a rotated amber diamond.
 *
 * Design system §Navigation/.side-brand: a 24px navy square at 7px radius
 * with an 8px amber diamond centred inside. Every realm's sidebar and every
 * app bar renders THIS, so the four products read as one system instead of
 * four differently-lettered squares.
 */
export default function BrandMark({
  size = 24,
  className = '',
}: {
  /** Tile edge in px. The diamond scales with it (1/3 of the tile). */
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`grid shrink-0 place-items-center bg-navy-600 ${className}`}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.29) }}
      aria-hidden
    >
      <i
        className="block bg-amber-500"
        style={{
          width: Math.round(size / 3),
          height: Math.round(size / 3),
          transform: 'rotate(45deg)',
          borderRadius: 2,
        }}
      />
    </span>
  );
}
